import {IPowerSource} from "../../data/data";
import {CLOSE_RESULTS_PANEL, OPEN_RESULTS_PANEL, RESET_RESULTS_PANEL} from "./action";
import {AnyAction} from "redux";


export function openResultsPanel() : AnyAction
{
    return {type: OPEN_RESULTS_PANEL, payload: {}};
}


export function closeResultsPanel() : AnyAction
{
    return {type: CLOSE_RESULTS_PANEL, payload: {}};
}



export function resetResultsPanel() : AnyAction
{
    return {type: RESET_RESULTS_PANEL, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/results.ts